// components/StepCard.js
import React, { useState } from "react";
import { Card, Button } from "antd";
import FeedbackModal from "../../treasury/bond/components/FeedbackModal";
import { useNavigate } from "react-router-dom";

/**
 * StepCard
 *
 * Props:
 * - current (number): zero-based index of the active step
 * - totalSteps (number): total number of steps in the wizard
 * - children (node): the form content for the current step
 * - onPrev (func): callback for Previous
 * - onNext (func): callback for Next
 * - onSubmit (func): callback for Submit (last step)
 * - onGoBack (func): callback for Go Back (first step)
 * - nextLabel (string): custom Next button label
 * - submitLabel (string): custom Submit button label
 * - cardStyle (object): override Card styles
 * - contentStyle (object): override inner content padding
 */
export default function StepCard({ current, totalSteps, children, onPrev, onNext, onSubmit, onGoBack, nextLabel, submitLabel, cardStyle = {}, contentStyle = {} }) {
  const isLast = current === totalSteps - 1;
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const navigate = useNavigate();

  const defaultCardStyle = {
    // maxWidth: isLast ? 744 : 560,

    boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
    borderRadius: "12px",
    ...cardStyle,
  };

  const handleClose = () => {
    setWarningModalVisible(false);
  };

  function onCancel() {
    navigate("/bond-contract", { replace: false });
  }

  return (
    <Card style={{ width: "100%" }}>
      <div
        style={{
          width: "100%",
          height: "720px",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            flex: 1,
            padding: "0 20px",
            height: "100%",
            position: "relative",
            width: "100%",
          }}
        >
          <div
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: "20px",
              height: "83%",
              width: "100%",
            }}
          >
            {children}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "15%",
              padding: "8px",
            }}
          >
            {current > 0 ? (
              <Button
                style={{
                  margin: "0 8px",
                  background: "#FFFFFF",
                  borderColor: "#D0D5DD",
                  height: "44px",
                  fontSize: "16px",
                }}
                onClick={onPrev}
              >
                Previous
              </Button>
            ) : (
              <Button
                style={{
                  margin: "0 8px",
                  height: 44,
                  fontSize: 16,
                  background: "#FFFFFF",
                  borderColor: "#D0D5DD",
                }}
                onClick={onGoBack}
              >
                Go Back
              </Button>
            )}

            {!isLast ? (
              <Button
                type="primary"
                style={{
                  background: "#BA24D5",
                  borderColor: "#BA24D5",
                  height: 44,
                  fontSize: 16,
                }}
                onClick={onNext}
              >
                {nextLabel || "Next"}
              </Button>
            ) : (
              <Button
                type="primary"
                style={{
                  background: "#BA24D5",
                  borderColor: "#BA24D5",
                  height: 44,
                  fontSize: 16,
                }}
                onClick={onSubmit}
              >
                {submitLabel || "Submit"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
